// import { Loading } from 'element-ui';
import { checkUrl } from '@/utils/utils'
import axios from 'axios';
import { Message } from 'element-ui';
import router from './router'
import { refreshToken } from '@/api/role'

window.$glob = {
  url: '',
  group: '',
  params: {},
  query: {},
  header: {}
};

// 解析URL参数
var query = window.location.search.substring(1);
if (query != '') {
  query = query.split("&");
  query.forEach(ele => {
    var pair = ele.split("=");
    window.$glob.params[pair[0]] = pair[1]
  })
}

// 创建axios实例
const service = axios.create({
  // baseURL: '/api', // 所有请求自动加 /api 前缀，触发代理
  timeout: 30000,
  validateStatus: function (status) {
    return status >= 200 && status <= 500;
  }
});

// 请求拦截器
service.interceptors.request.use(config => {
  // 设置token (统一使用小写token)
  const token = localStorage.getItem('Token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  
  // 处理URL参数替换
  let url = config.url;
  const globParams = url.match(/\$\{(.+?)\}/g);
  (globParams || []).forEach(ele => {
    const key = ele.replace('${', '').replace('}', '');
    url = url.replace(ele, window.$glob[key] || '');
  });
  config.url = url;
  
  // 处理基础URL
  if (!checkUrl(config.url)) {
    config.url = window.$glob.url + config.url;
  }
  
  // 合并全局header
  const header = window.$glob.header || {};
  config.headers = { ...config.headers, ...header };
  
  // 合并全局query参数
  const data = window.$glob.query || {};
  const method = config.method?.toLowerCase() || '';
  
  if (['get', 'delete'].includes(method)) {
    config.params = { ...config.params, ...data };
  } else if (['post', 'put'].includes(method)) {
    if (!(config.data instanceof FormData)) {
      config.data = { ...config.data, ...data };
    }
  }
  
  // 处理代理请求
  if (config.headers.proxy && !(config.data instanceof FormData)) {
    const headers = {};
    for (const ele in config.headers) {
      if (typeof config.headers[ele] !== 'object') {
        headers[ele] = config.headers[ele];
      }
    }
    
    const form = {
      url: config.url,
      method: config.method,
      headers: headers
    };
    
    const key = ['get', 'delete'].includes(method) ? 'params' : 'data';

    form[key] = config[key] instanceof FormData 
    ? config[key] 
    : JSON.stringify(config[key]);
    
    config.url = window.$website.url + '/visual/proxy';
    config.method = 'post';
    config.data = form;
  }
  
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
let isRefreshing = false;
let retryRequestsQueue = [];

service.interceptors.response.use(
  response => {
    const status = response.status;
    const config = response.config;
    
    // 非200状态码处理
    if (status !== 200) {
      const errorMessage = response.data?.msg || `${status} ${response.statusText}`;
      
      // Token过期处理
      if (status === 402) {
        console.log('Token过期，尝试刷新...');
        const refresh_token = localStorage.getItem('refreshToken');
        console.log(111,refresh_token)
        if (refresh_token) {
          // 如果正在刷新token，将请求加入队列
          if (isRefreshing) {
            return new Promise((resolve, reject) => {
              retryRequestsQueue.push(() => {
                const token = localStorage.getItem('Token');
                if (config.headers && token) {
                  config.headers['Authorization'] = `Bearer ${token}`;
                }
                resolve(service(config));
              });
            });
          }
          
          // 开始刷新token
          isRefreshing = true;
          
          return new Promise((resolve, reject) => {
            console.log(111,refresh_token)
            refreshToken({ token: refresh_token })
              .then(res => {
                console.log('Token刷新成功');
                
                // 确保响应结构正确
                const newToken = res?.data?.data?.token;
                if (!newToken) {
                  throw new Error('刷新Token失败：无效的响应格式');
                }
                
                // 存储新Token
                localStorage.setItem('Token', newToken);
                
                // 更新请求头并重新发送请求
                if (config.headers) {
                  config.headers['Authorization'] = `Bearer ${newToken}`;
                }
                
                // 处理队列中的请求
                retryRequestsQueue.forEach(cb => cb());
                retryRequestsQueue = [];
                
                resolve(service(config));
              })
              .catch(err => {
                console.error('刷新Token失败:', err);
                // 清除认证信息
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('Token');
                localStorage.setItem('isLogin', false);
                
                // 跳转登录页
                redirectToLogin();
                reject(new Error('Token刷新失败，请重新登录'));
              })
              .finally(() => {
                isRefreshing = false;
              });
          });
        } else {
          // 没有刷新token，直接跳转登录页
          localStorage.setItem('isLogin', false);
          redirectToLogin();
          return Promise.reject(new Error('未找到刷新Token，请重新登录'));
        }
      } else {
        Message({
          message: errorMessage,
          type: 'error'
        });
        // 其他状态码处理
        if ([406, 405].includes(status)) {
          localStorage.setItem('isLogin', false);
          redirectToLogin();
        }
        
        if (config?.url?.includes('login') && status === 405) {
          localStorage.setItem('isLogin', false);
          redirectToLogin();
        }
        
        return Promise.reject(new Error(errorMessage));
      }
    }
    
    return response;
  },
  error => {
    console.error('网络请求错误:', error);
    Message({
      message: '网络请求失败',
      type: 'error'
    });
    return Promise.reject(error);
  }
);

// 封装路由跳转逻辑
function redirectToLogin() {
  if (router && typeof router.replace === 'function') {
    setTimeout(() => {
      router.replace({ path: '/' });
    }, 2000);
  } else {
    console.error('Router未定义，使用window.location跳转');
    setTimeout(() => {
      window.location.href = '/';
    }, 2000);
  }
}

export default service;